import { render, staticRenderFns } from "./DetectionDetailRequestLayout.vue?vue&type=template&id=5718b610&scoped=true"
import script from "./DetectionDetailRequestLayout.vue?vue&type=script&lang=js"
export * from "./DetectionDetailRequestLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5718b610",
  null
  
)

export default component.exports